export * from './summary';
export * from './product-category-routing.module';
export * from './product-category.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/index.ts